export interface FavouriteItemWire {
  v: number;
  d?: string;
  c?: number;
}

export interface FavouriteSearchWire {
  code: FavouriteItemWire;
  owners: FavouriteItemWire[];
  parent: FavouriteItemWire;
  disabled: string;
  shared: boolean;
  invalidOwners: number[];
}

export interface FavouriteAdminListWire {
  totalNumberOfResults: number;
  editableNumberOfResults?: number;
  results: FavouriteSearchWire[];
}

export enum ChangeOptionType {
  Add,
  Replace,
  Remove
}
